import axios from "../../../axios"
import { paramsObjToGraphQLParams } from "@/utils/index.js"

export default {
  fetch(queryData) {
    return axios.post('', {
      query: `
        query {
          dailyCovers ${paramsObjToGraphQLParams(queryData)} {
            order_by,
            pagination_page,
            pagination_limit,
            total_pages,
            items {
              id,
              url,
              picture_url,
              created_at,
              activated,
              schedule_publish_at,
            }
          }
        }
      `
    })
  },
  add(dailyCover) {
    return axios.post('', {
      query: `
        mutation {
          createDailyCover (
            url: "${dailyCover.url}",
            picture_url: "${dailyCover.picture_url}",
            schedule_publish_at: ${dailyCover.schedule_publish_at !== null ? `"${dailyCover.schedule_publish_at}"` : null}
          ) {
            id,
            url,
            picture_url,
            created_at,
            activated,
            schedule_publish_at,
          }
        }
      `
    })
  },
  delete(dailyCoverId) {
    return axios.post('', {
      query: `
        mutation {
          deleteDailyCover (
            id: ${dailyCoverId}
          )
        }
      `
    })
  },
  infos(dailyCoverId) {
    return axios.post('', {
      query: `
        query {
          dailyCoverInfos (
            id: ${dailyCoverId}
          ) {
            id,
            url,
            picture_url,
            created_at,
            activated,
            schedule_publish_at,
          }
        }
      `
    })
  }
}
